import { render, staticRenderFns } from "./_MenuItem.vue?vue&type=template&id=198cf705&scoped=true&"
import script from "./_MenuItem.vue?vue&type=script&lang=js&"
export * from "./_MenuItem.vue?vue&type=script&lang=js&"
import style0 from "./_MenuItem.vue?vue&type=style&index=0&id=198cf705&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198cf705",
  null
  
)

export default component.exports